"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationResult_1 = require("./ValidationResult");

var ValueDesc_1 = require("./ValueDesc");

var ParsedDesc =
/*#__PURE__*/
function (_ValueDesc_1$ValueDes) {
  _inherits(ParsedDesc, _ValueDesc_1$ValueDes);

  function ParsedDesc(parser, description, validators) {
    var _this;

    _classCallCheck(this, ParsedDesc);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ParsedDesc).call(this, description));
    _this.parser = parser;
    _this.validators = validators;
    return _this;
  }
  /**
   * Converts input material to required type or null if input is null or undefined.
   * @param input "something" to be converted to given property
   * @param level the level of the validation - it can be faster or slower and more thorough
   * @throws Error in case that input is not convertible or or validation fails
   */


  _createClass(ParsedDesc, [{
    key: "validate",
    value: function validate(input, level) {
      if (input === null || input === undefined) {
        return new ValidationResult_1.ValidationError('NULL_NOT_ALLOWED', this.description.nameKey);
      }

      var res = this.parser.parse(input, level);

      if (res.valid) {
        res = this.validators.reduce(function (r, v) {
          return r.validate(v, level);
        }, res);
      } else {
        // Lets make the error from parser more informative
        var err = res;
        var args = err.messageArgs;
        args.push(this.description.nameKey);
        res = new ValidationResult_1.ValidationError(err.messageKey, args);
      }

      return res;
    }
    /**
     * Retrieves validator of specified type from validator list (if it on the list).
     * @param spec type (constructor) of validator to be retrieved
     * @param <V> validator type
     * @return validator of provided type, or null if the validator is not found
     */

  }, {
    key: "validatorOf",
    value: function validatorOf(spec) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.validators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var v = _step.value;

          if (v instanceof spec) {
            return v;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    }
    /**
     * Finds validator of provided type and maps it to some value.
     * @param spec type (constructor) of validator to be retrieved
     * @param map mapping function from validator to result value
     * @param <V> validator type
     * @param <U> result value type
     * @returns result value or null of validator is not found
     * @see validatorOf
     */

  }, {
    key: "mapValidator",
    value: function mapValidator(spec, map) {
      var v = this.validatorOf(spec);

      if (v !== null) {
        return map(v);
      } else {
        return null;
      }
    }
    /**
     * Finds validator of provided type and runs provided block of code if found.
     * @param spec type (constructor) of validator to be retrieved
     * @param block code to be run with validator
     * @param <V> validator type
     * @see validatorOf
     */

  }, {
    key: "forValidator",
    value: function forValidator(spec, block) {
      var v = this.validatorOf(spec);

      if (v !== null) {
        block(v);
      }
    }
  }]);

  return ParsedDesc;
}(ValueDesc_1.ValueDesc);

exports.ParsedDesc = ParsedDesc;